import { render, staticRenderFns } from "./DishDetail.vue?vue&type=template&id=43482b2c&scoped=true&"
import script from "./DishDetail.vue?vue&type=script&lang=js&"
export * from "./DishDetail.vue?vue&type=script&lang=js&"
import style0 from "./DishDetail.vue?vue&type=style&index=0&id=43482b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43482b2c",
  null
  
)

export default component.exports